import * as React from 'react';
import { Route, Redirect } from 'react-router-dom';
import RouteWithSubRoutes from '../route_with_sub_routes/RouteWithSubRoutes';

const style = require('./SupplierLocationsPage.less');

export default class SupplierLocationsPage extends React.Component<any, null> {
	constructor(props) {
		super(props);
	}

	render() {
		return (
			<div>
				<Route
					path="/supplier/locations"
					exact={true}
					render={(props) => (
						<Redirect
							to={{
								pathname: '/supplier/locations/overview',
							}}
						/>
					)}
				/>
				{this.props.childRoutes.map((r, i) => (
					<RouteWithSubRoutes key={i} {...r} />
				))}
			</div>
		);
	}
}
